export class LayoutState {
  /**
   * @var {{}}
   */
  layouts;

  /**
   *  Cloned widgets in current layout in builder mode
   */
  originalLayoutWidgets;

  /**
   * @var {boolean}
   */
  viewingLayoutPreview;

  constructor() {
    this.layouts = {};
    this.originalLayoutWidgets = {};
    this.viewingLayoutPreview = false;
  }
}
